import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom } from 'rxjs';
import { VerifyUuidsPayload, VerifyUuidsResult } from '@mira-avant/mtlibs';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root',
})
export class Security {
	private readonly BASE_PATH = 'security';

	public loading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

	constructor(private api: ApiService) {}

	private async withLoading<T>(operation: () => Promise<T>): Promise<T> {
		this.loading$.next(true);
		try {
			return await operation();
		} finally {
			this.loading$.next(false);
		}
	}

	public async verify$(uuidPack: VerifyUuidsPayload): Promise<boolean> {
		return this.withLoading(async () => {
			try {
				const result = await firstValueFrom(
					this.api.post<VerifyUuidsResult>(`${this.BASE_PATH}/verify-uuids`, uuidPack)
				);

				return result.result;
			} catch (error) {
				console.error('Error during security verify$ for uuids:', uuidPack, error);
				return false;
			}
		});
	}
}
